import { render } from "./RegistrationForm.vue?vue&type=template&id=47e1df70&scoped=true"
import script from "./RegistrationForm.vue?vue&type=script&lang=js"
export * from "./RegistrationForm.vue?vue&type=script&lang=js"

import "./RegistrationForm.vue?vue&type=style&index=0&id=47e1df70&lang=css"
import "./RegistrationForm.vue?vue&type=style&index=1&id=47e1df70&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47e1df70"]])

export default __exports__